import { Component, OnInit, TemplateRef, HostListener, SimpleChanges } from '@angular/core';
import { TSFuntionService } from '../../services/ts-funtion.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { BusinessDayService } from '../../services/business-day.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { SWAlertService } from '../../services/swalert.service';
import { Router } from '@angular/router';
import { array } from '@amcharts/amcharts4/core';
declare var Uploadfiles, Clearuploadfile, SetData, _Path, Extension, createlist: any
declare var ArrFile: any[];

@Component({
  selector: 'app-approve',
  templateUrl: './approve.component.html',
  styleUrls: ['./approve.component.css']
})
export class ApproveComponent implements OnInit {

  constructor(private System: TSFuntionService,
    private http: HttpClient,
    private formBuilder: FormBuilder,
    private BusinessDay: BusinessDayService,
    private modalService: BsModalService,
    private SW: SWAlertService,
    private router: Router) { }
  HTML_FLOW: string;
  sID: string;
  sComCode: string
  nRole: number
  sRole: boolean;
  btnReject: boolean = false;
  btnApprove: boolean = false;
  btnPrint: boolean = false;
  btnRecall: boolean = false;
  Data: any;
  TreqItem: any[] = [];
  TreqLine: any[] = [];
  Settodate: Date;
  nworkDay: any;
  IsReqUrgent: true;
  holiday: any[] = [];
  ArrTransactionHistory: Array<any> = [];
  nform: any;
  IsForNoBank: boolean = false;
  IsForB2C: boolean = false;
  IsForB2P: boolean = false;
  IsForJV: boolean = false;
  IsOneTimeVendor: boolean = true;
  IsConfidential: boolean = true;
  IsPOinvoice: boolean = true;
  IsCountryThai: boolean = true;
  IsNoData: boolean = true;
  ApproveFrom: FormGroup;
  modalRef: BsModalRef;
  sModalDetail: BsModalRef;
  onetimeEmp: boolean = false;
  onetimevendor: boolean = false;
  IsclearAdv: boolean = false;
  clicked: boolean  = false;
  ResultPermission: boolean;
  section: string;
  Iscomment: boolean = false;
  Iscomment2: boolean = false;
  comment: string;
  commentSSC: string;
  TransactionHistory: string;
  sReqID: string;
  txt_vc1: string;
  txt_vn1: string;
  txt_vc2: string;
  txt_vn2: string;
  in_no: string;
  in_d: string;
  txt_total: string;
  refNo: String = null;
  IsSkip: boolean = false;
  sCurrency: string = null;
  isFlow: boolean = false;
  nUserID: number;
  IsTxtpay: boolean = true;
  txtpay: string = null;
  sNetAmount: string = null;
  arrExcel: any[] = [];
  urgentDay: number = 6;

  async ngOnInit() {
    this.System.BlockUI();
    this.setform();
    //Get ID from URL
    let ID: string = this.System.GetQuerySTR('str');
    this.sID = await this.System.Decrypt(ID);
    this.getHoliday();
    this.getData(this.sID);
    //set hearder flow
    this.BindFlow(this.sID);
    //Check Permission
    let ObjData = {
      sRequestID: this.sID,
      nMenuID: 22
    }
    document.getElementById("divFlowChart").style.width = (document.getElementById("divFlowResize").clientWidth - 5) + "px";
    this.Settodate = this.BusinessDay.SetToday(this.holiday);
  }
  // set form control
  setform() {
    //get secsion
    let ua = this.System.GetUserStorage();
    this.sComCode = ua.sCompCode;
    this.nRole = ua.nRole;
    this.nUserID = ua.nUserID;
    //create form control
    this.ApproveFrom = this.formBuilder.group({
      sRequestID: [null],
      sRequestCode: [null],
      dPostingDate: [null],
      dDueDate: [null],
      sCompCode: [null],
      nContactID: [null],
      sContactName: [null],
      sComName: [null],
      dRequestDate: [null],
      sUnitName: [null],
      sEmail: [null],
      sTel: [null],
      nReqType: [null],
      sReqType: [null],
      sDescription: [null],
      sOtherRefNoFIDocNo: [null],
      sInvoiceRef: [null],
      sYearInvoiceRef: [null],
      sCopyReqCode: [null],
      sPONo: [null],
      sPOitem: [null],
      sMatDoc: [null],
      sPORemark: [null],
      sReceiveType: [null],

      //=====================TreqItrm======================//
      nItemNo: [null],
      cVenderMaster: [null],
      sVendorCode: [null],
      sVendorName: [null],
      sTAXID: [null],
      sVendorBranch: [null],
      sVendorAddress: [null],
      sVendorCode_PX: [null],
      sVendorName_PX: [null],
      sTAXID_PX: [null],
      sVendorBranch_PX: [null],
      sVendorAddress_PX: [null],
      sInvoiceNo: [null],
      dInvoiceDate: [null],
      sInvoiceDesc: [null],
      sVATType: [null],
      sCurrency: [null],
      nExcludeVAT: [null],
      nVAT: [null],
      nIncludeVAT: [null],
      sWHTType: [null],
      sWHTCode: [null],
      WHD_Desc: [null],
      WHD_Desc2: [null],
      nWHTRate: [null],
      nWHTVal: [null],
      sWHTType2: [null],
      sWHTCode2: [null],
      nWHTRate2: [null],
      nWHTVal2: [null],
      nWHTBase: [null],
      nWHTBase2: [null],
      nOfficeType: [null],
      sOfficeType: [null],
      nOfficeType_PX: [null],
      sOfficeType_PX: [null],
      // cbOffice_PX
      nInvoiceType: [null],
      //===============onetime vendor====================//
      IsVendorOneTime: [null],
      sCountryID: [null],
      sProvCode: [null],
      sAmpCode: [null],
      sTumbonCode: [null],
      sPostCode: [null],
      sPhoneNumber: [null],
      sFaxNumber: [null],
      sEmail_vendor: [null],
      sAddressOneTime: [null],
      sCountryName: [null],
      sAmpName: [null],
      sProvname: [null],
      sTumbonName: [null],
      //===============Bank====================//
      sPaymentType: [null],
      sBankName: [null],
      sAccountName: [null],
      sAccountNo: [null],
      sBankKey: [null],
      sBankOther: [null],
      sChequeNo: [null],
      dChequeDate: [null],
      nChequeAmount: [null],
      nGrandTotalAmtInvoice: [null],
      nGrandTotalAmtVat: [null],
      nGrandTotalWithholdingTax: [null],
      nGrandTotalAmt: [null],
      IsUploadExcelFile: [false],
      //======================comment=================//
      sComment: [null, Validators.required],
      sCommentSSC: [null, Validators.required]
      //=======================clear AD===============//
      , nAdvanceAmount: [null]
      , nCumulativeAmount: [null]
      , nClearingAmount: [null]
      , nPayAmount: [null]
      , cRefund: [null]
      , dRefund: [null]
      //=======================Approver===============//
      , sApprove1: [null]
      , sApprove2: [null]
      , sRefAdvanceNo: [null]
    });
  }
  //#region 'getHoliday'
  getHoliday() {
    this.http.get<any>(this.System.SiteName + "api/Approve/GetHoliday").subscribe(res => {
      this.holiday = res.map(({ dDate }) => new Date(dDate)) //get value from Holidaycontroller
    });
  }
  //#endregion
  //#region 'getDataByID'
  async getData(sReqID: string) {
    let ua = this.System.GetUserStorage();
    this.sComCode = ua.sCompCode;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })
    let search = { sReqID: sReqID }
    let Datasearch = JSON.stringify(search)
    var data2: any;
    await this.http.get(this.System.SiteName + "api/_Paytovendor/GetTransactionHistory/" + encodeURIComponent(String(sReqID))).toPromise().then(Data => data2 = Data)
    this.ArrTransactionHistory = data2;
    this.http.post<any>(this.System.SiteName + "api/Approve/GetData", Datasearch, { headers }).toPromise().then(async data => {
      this.Data = data;
      let arrItemNo = [];
      let arrVenderMaster = [];
      this.sReqID = sReqID;
      //==========================setformcontrol==============//
      let sReceiveType = '';
      switch (this.Data[0].nReceiveTypeB2C) {
        case 1:
          sReceiveType = 'Invoice';
          break;
        case 2:
          sReceiveType = 'Debit Note';
          break;
        case 3:
          sReceiveType = 'Credit Note';
          break;
        case 4:
          sReceiveType = 'Receipt';
          break;
        case 5:
          sReceiveType = 'Receipt / Tax Invoice';
          break;
      }
      this.ApproveFrom.patchValue({
        sRequestID: this.Data[0].sRequestID,
        sRequestCode: this.Data[0].sRequestCode,
        dPostingDate: new Date(this.Data[0].dPostingDate),
        dDueDate: new Date(this.Data[0].dDueDate),
        sCompCode: this.Data[0].sCompCode,
        nContactID: this.Data[0].nContactID,
        sContactName: this.Data[0].sContactName,
        sComName: this.Data[0].sComName,
        dRequestDate: new Date(this.Data[0].dRequestDate),
        sUnitName: this.Data[0].sUnitName,
        sEmail: this.Data[0].sEmail,
        sTel: this.Data[0].sTel,
        nReqType: this.Data[0].nReqType,
        sReqType: this.Data[0].sReqType,
        sDescription: this.Data[0].sDescription,
        sOtherRefNoFIDocNo: this.Data[0].sOtherRefNoFIDocNo,
        sPONo: this.Data[0].sPONo,
        sPOitem: this.Data[0].sPOitem,
        sMatDoc: this.Data[0].sMatDoc,
        sPORemark: this.Data[0].sPORemark,
        sReceiveType: sReceiveType,
        sInvoiceRef: this.Data[0].sInvoiceRef,
        sYearInvoiceRef: this.Data[0].sYearInvoiceRef,
        sCopyReqCode: this.Data[0].CopyCode,
        //=============== cVenderMaster=M =============//
        sVendorCode: this.Data[0].sVendorCode == null ? this.Data[0].sVendorCode1 : this.Data[0].sVendorCode == '' ? this.Data[0].sVendorCode1 : this.Data[0].sVendorCode,
        sVendorName: this.Data[0].sVendorName,
        sTAXID: this.Data[0].sTAXID,
        sVendorAddress: this.Data[0].sVendorAddress,
        nExcludeVAT: this.Data[0].nExcludeVAT,
        sCurrency: this.Data[0].sCurrency,
        sInvoiceDesc: this.Data[0].sInvoiceDesc,
        sOfficeType: this.Data[0].nOfficeType == 1 ? "Head Office" : "Branch",
        sVendorBranch: this.Data[0].sVendorBranch,
        //===============Bank===========================//
        sPaymentType: this.Data[0].sPaymentType == "C" ? "Cheque" : "Transfer form Bank Account",
        sBankName: this.Data[0].sBankName,
        sAccountName: this.Data[0].sPaymentType == "C" ? null : this.Data[0].sAccountName,
        sAccountNo: this.Data[0].sPaymentType == "C" ? null : this.Data[0].sAccountNo,
        sBankKey: this.Data[0].sPaymentType == "C" ? null : this.Data[0].sBank_branch,
        sBankOther: this.Data[0].sBankOther,
        sChequeNo: this.Data[0].sChequeNo,
        dChequeDate: new Date(this.Data[0].dChequeDate),
        nChequeAmount: this.Data[0].nChequeAmount,
        nGrandTotalAmt: this.Data[0].nGrandTotalAmt,
        nGrandTotalAmtVat: this.Data[0].nGrandTotalAmtVat,
        nGrandTotalWithholdingTax: this.Data[0].nGrandTotalWithholdingTax,
        nGrandTotalAmtInvoice: this.Data[0].nGrandTotalAmtInvoice,
        //=================clear AD=====================//
        nAdvanceAmount: this.Data[0].nAdvanceAmount,
        nCumulativeAmount: this.Data[0].nCumulativeAmount,
        nClearingAmount: this.Data[0].nClearingAmount,
        nPayAmount: this.Data[0].nPayAmount,
        cRefund: this.Data[0].cRefund == "N" ? null : "Final Clearing",
        dRefund: this.Data[0].cRefund == "N" ? null : new Date(this.Data[0].dRefund),
        //=======================Approver====================//
        sApprove1: this.Data[0].sApprove1,
        sApprove2: this.Data[0].sApprove2,
        sRefAdvanceNo: this.Data[0].sRefNo,
        sComment: this.Data[0].sComment,
        sCommentSSC: this.Data[0].sCommentSSC,
        IsUploadExcelFile: this.Data[0].IsUploadExcelFile,
      })
      if (this.Data[0].IsRoService) this.urgentDay = 8;

      if (this.ApproveFrom.get("IsUploadExcelFile").value == true) {
        let addText = '';
        if (this.Data[0].nReqType == '80') {
          addText = 'JV';
        }
        await this.http.get(this.System.SiteName + "api/_Paytovendor/GetRequestExcel" + addText + "/" + sReqID + "").toPromise().then(Data => data = Data)
        for (var i = 0; i < data.length; i++) {
          if (this.Data[0].nReqType == '80') {
            let chunks2 = data[i].sPostingDate.split("/");
            var sPostingDate = new Date(chunks2[2], chunks2[1] - 1, chunks2[0]);
            data[i].sPostingDate = sPostingDate;
          }
          else {
            let chunks1 = data[i].dInvoiceDate.split("/");
            let chunks2 = data[i].dPostingDate.split("/");
            let chunks3 = data[i].dDueDate.split("/");
            data[i].sNo = (i + 1).toString();
            var dInvoiceDate = new Date(chunks1[2], chunks1[1] - 1, chunks1[0]);
            var dPostingDate = new Date(chunks2[2], chunks2[1] - 1, chunks2[0]);
            var dDueDate = new Date(chunks3[2], chunks3[1] - 1, chunks3[0]);
            data[i].dInvoiceDate = dInvoiceDate;
            data[i].dPostingDate = dPostingDate;
            data[i].dDueDate = dDueDate;
          }
        
        }
        this.arrExcel = data;
      }
      this.IsSkip = this.Data[0].cSkipApprove1 == "Y" ? true : false;
      if (this.Data[0].nReqType == '90') {
        this.IsCheque = this.Data[0].sPaymentType == "C" ? true : false
      }
      this.IsOneTimeVendor = this.Data[0].IsVendorOneTime;
      this.IsConfidential = this.Data[0].IsConfidential;
      this.IsPOinvoice = this.Data[0].IsPOinvoice;
      //================Onetimevendor==============//
      if (this.IsOneTimeVendor) {
        this.ApproveFrom.patchValue({
          sCountryID: this.Data[0].sCountryName,
          sProvCode: this.Data[0].sProvName,
          sAmpCode: this.Data[0].sAmpName,
          sTumbonCode: this.Data[0].sTumbonName,
          sPostCode: this.Data[0].sPostCode,
          sPhoneNumber: this.Data[0].sPhoneNumber,
          sFaxNumber: this.Data[0].sFaxNumber,
          sEmail_vendor: this.Data[0].sEmail,
          sAddressOneTime: this.Data[0].sAddressOneTime,
        })
        this.onetimeEmp = true;
        if (this.Data[0].sCountryID == 213) {
          this.IsCountryThai = true;
        } else {
          this.IsCountryThai = false;
        }
      }
      //let date = new Date(this.Data[0].dRequestDate);
      //this.nworkDay = this.BusinessDay.setDueDatebyDate(date, new Date(this.Data[0].dDueDate), this.holiday)
      //this.nworkDay = this.nworkDay < 0 ? 0 : this.nworkDay;
      this.nworkDay = this.Data[0].nReqUrgentDay;
      this.IsReqUrgent = this.Data[0].IsReqUrgent;
      //=====================แยก TreqItem=====================
      for (var i = 0; i < this.Data.length; i++) {
        let ItemNo = arrItemNo.includes(this.Data[i].nItemNo);
        let VenderMaster = arrVenderMaster.includes(this.Data[i].cVenderMaster);
        if (this.Data[i].sRequestID != null) {

          if (!ItemNo || !VenderMaster) {
            arrItemNo.push(this.Data[i].nItemNo);
            arrVenderMaster.push(this.Data[i].cVenderMaster);
            this.TreqItem.push({
              sRequestID: this.Data[i].sRequestID
              , nItemNo: this.Data[i].nItemNo
              , cVenderMaster: this.Data[i].cVenderMaster
              , sVendorCode: this.Data[i].sVendorCode1
              , sVendorName: this.Data[i].sVendorName
              , sTAXID: this.Data[i].cVenderMaster == 'M' ? this.Data[i].sTAXID : this.Data[i].sTAXID1
              , sVendorBranch: this.Data[i].sVendorBranch
              , sVendorAddress: this.Data[i].sVendorAddress
              , sInvoiceNo: this.Data[i].sInvoiceNo
              , dInvoiceDate: this.Data[i].dInvoiceDate
              , sInvoiceDesc: this.Data[i].sInvoiceDesc
              , sVATType: this.Data[i].sVATType
              , sCurrency: this.Data[i].sCurrency1
              , nExcludeVAT: this.Data[i].nExcludeVAT
              , nVAT: this.Data[i].sVATType == "VZ" ? null : this.Data[i].amtVat
              , nIncludeVAT: this.Data[i].nIncludeVAT
              , sWHTType: this.Data[i].sWHTType
              , sWHTCode: this.Data[i].nWHTID + ""
              , nWHTRate: this.Data[i].nWHTRate
              , WHD_Desc: this.Data[i].WHD_Desc
              , WHD_Desc2: this.Data[i].WHD_Desc2
              , nWHTVal: this.Data[i].nWHTVal
              , sWHTType2: this.Data[i].sWHTType2
              , sWHTCode2: this.Data[i].sWHTCode2
              , nWHTRate2: this.Data[i].nWHTRate2
              , nWHTVal2: this.Data[i].nWHTVal2
              , nWHTBase: this.Data[i].nWHTBase
              , nWHTBase2: this.Data[i].nWHTBase2
              , sReference: this.Data[i].sReference
              , nOfficeType: this.Data[i].nOfficeType
              , nInvoiceType: this.Data[i].InvoiceType
              //, sInvoiceType: this.Data[i].InvoiceType == ?
              , IsVendorOneTime: this.Data[i].IsVendorOneTime
              , sCountryID: this.Data[i].sCountryID
              , sProvCode: this.Data[i].sProvCode
              , sAmpCode: this.Data[i].sAmpCode
              , sTumbonCode: this.Data[i].sTumbonCode
              , sPostCode: this.Data[i].sPostCode
              , sPhoneNumber: this.Data[i].sPhoneNumber
              , sFaxNumber: this.Data[i].sFaxNumber
              , sEmail_vendor: this.Data[i].sEmail1 == null ? (this.Data[i].sEmail2 == null ? this.Data[i].sEmail3 == null ? "" : this.Data[i].sEmail3 : this.Data[i].sEmail2) : this.Data[i].sEmail1
              //this.Data[i].sEmail1 == null ? this.Data[i].sEmail2 : this.Data[i].sEmail2
              , sAddressOneTime: this.Data[i].sAddressOneTime
              , sCountryName: this.Data[i].sCountryName
              , sAmpName: this.Data[i].sAmpName
              , sProvname: this.Data[i].sProvName
              , sTumbonName: this.Data[i].sTumbonName
            })
          }
        }
      }
      //==========================Onetime Vendor===============================
      if (this.Data[0].IsVendorOneTime) {
        this.ApproveFrom.patchValue({
          IsVendorOneTime: this.Data[0].IsVendorOneTime
          , sCountryID: this.Data[0].sCountryID
          , sProvCode: this.Data[0].sProvCode
          , sAmpCode: this.Data[0].sAmpCode
          , sTumbonCode: this.Data[0].sTumbonCode
          , sPostCode: this.Data[0].sPostCode
          , sPhoneNumber: this.Data[0].sPhoneNumber
          , sFaxNumber: this.Data[0].sFaxNumber
          , sEmail_vendor: this.Data[0].sEmail1 != null ? this.Data[0].sEmail1 : this.Data[0].sEmail2
          , sAddressOneTime: this.Data[0].sAddressOneTime
          , sCountryName: this.Data[0].sCountryName
          , sAmpName: this.Data[0].sAmpName
          , sProvname: this.Data[0].sProvName
          , sTumbonName: this.Data[0].sTumbonName
        })
      }

      let Cur = this.Data[0].sCurrency
      this.sCurrency = Cur;
      //============TreqLine====================//
      for (var i = 0; i < this.Data.length; i++) {
        if (this.Data[i].nLineNo != null) {
          if (this.Data[i].nReqType === 90 && this.Data[i].nItemNo === 1) {
            if (i === 0) {
              this.TreqLine.push({
                sInvoiceNo: this.Data[i].sInvoiceDesc,
                sRequestID: this.Data[i].sRequestID,
                nItemNo: this.Data[i].nItemNo,
                nLineNo: this.Data[i].nLineNo,
                sGL: this.Data[i].sGL,
                sGLName: this.Data[i].sGLName,
                sCCTR: this.Data[i].sCCTR,
                sIO: this.Data[i].sIO,
                sPTC: this.Data[i].sPTC,
                sText: this.Data[i].sInvoiceDesc1,
                nAmtExcldVAT: this.Data[i].nExcludeVAT,
                nWHTVal: this.Data[i].nWHTVal,
                cActive: this.Data[i].cActive,
                sVATType: this.Data[0].nReqType != 80 ? this.Data[i].sVATType : this.Data[i].nReceiveType1 == 1 ? "Dr." : "Cr.",
                dInvoiceDate: new Date(this.Data[i].dInvoiceDate),
                sCurrency: Cur,
              })
            }
          }
          else {
            this.TreqLine.push({
              sInvoiceNo: this.Data[i].nReqType === 90 ? this.Data[i].sInvoiceDesc : this.Data[i].sInvoiceNo,
              sRequestID: this.Data[i].sRequestID,
              nItemNo: this.Data[i].nItemNo,
              nLineNo: this.Data[i].nLineNo,
              sGL: this.Data[i].sGL,
              sGLName: this.Data[i].sGLName,
              sCCTR: this.Data[i].sCCTR,
              sIO: this.Data[i].sIO,
              sPTC: this.Data[i].sPTC,
              sText: this.Data[i].sText,
              nAmtExcldVAT: this.Data[i].nAmtExcldVAT,
              cActive: this.Data[i].cActive,
              sVATType: this.Data[0].nReqType != 80 ? this.Data[i].sVATType : this.Data[i].nReceiveType1 == 1 ? "Dr." : "Cr.",
              dInvoiceDate: new Date(this.Data[i].dInvoiceDate),
              sCurrency: Cur,
            })
          }
        }
      }
      //===================================set form=========================//
      this.IsNoData = this.TreqLine.length == 0 ? true : false
      this.IsclearAdv = this.Data[0].nReqType == 30 ? true : false;
      //========================= set section 3 && 4=======================//
      var lastSection = 0;
      switch (this.Data[0].nReqType) {
        case 20:
          this.nform = 1;
          this.section = "Section 3 : Approval record"
          this.comment = "Section 4 : Comments";
          lastSection = 4;
          break
        case 12:
        case 40:
          this.nform = 2;
          this.section = "Section 4 : Approval record"
          this.comment = "Section 5 : Comments";
          lastSection = 5;
          break
        case 30:
          this.nform = 3;
          this.section = "Section 4 : Approval record"
          this.comment = "Section 5 : Comments";
          lastSection = 5;
          break
        case 11:
        case 10:
        case 50:
        case 60:
        case 61:
        case 70:
        case 71:
        case 90:
          this.nform = 4;
          this.section = "Section 4 : Approval record"
          this.comment = "Section 5 : Comments";
          lastSection = 5;
          break;
        case 80:
          this.nform = 5;
          this.section = "Section 3 : Approval record"
          this.comment = "Section 4 : Comments";
          lastSection = 4;
          break;
      }
      //=====================set text===============================//
      //wording by req type.
      let vendor_c = 'Vendor Code';
      let vendir_n = 'Vendor Name';
      let customer_c = 'Customer Code';
      let customer_n = 'Customer Name';
      let invoice_no = 'Invoice/Receipt No.';
      let invoice_d = 'Invoice Date';
      let total_v = 'Total Amount of Invoice/Receipt';
      let emp_c = 'Employee Code';
      let emp_n = 'Employee Name';
      let rec_no = 'Receipt No.';
      let rec_d = 'Receipt Date ';
      let total_emp = 'Total Amount of Receipt';
      let PC_c = 'PC Code';
      let PC_n = 'PC Name';
      switch (this.Data[0].nReqType) {
        case 10:
        case 11:
        case 50:
        case 60:
        case 61:
          this.txt_vc1 = vendor_c;
          this.txt_vn1 = vendir_n;
          this.txt_vc2 = vendor_c;
          this.txt_vn2 = vendir_n;
          this.in_no = invoice_no;
          this.in_d = invoice_d;
          this.txt_total = total_v;
          break
        case 70:
        case 71:
          this.IsForNoBank = true;
          this.txt_vc1 = customer_c;
          this.txt_vn1 = customer_n;
          this.txt_vc2 = customer_c;
          this.txt_vn2 = customer_n;
          this.in_no = 'PO/Quotation';
          this.in_d = invoice_d;
          this.txt_total = total_v;
          this.IsForB2C = true;
          break
        case 80:
          this.IsForNoBank = true;
          this.IsForJV = true;
          break
        case 90:
          this.txt_vc1 = customer_c;
          this.txt_vn1 = customer_n;
          this.txt_vc2 = customer_c;
          this.txt_vn2 = customer_n;
          this.in_no = invoice_no;
          this.in_d = invoice_d;
          this.txt_total = total_v;
          this.IsForB2P = true;
          break
      case 12:
        case 20:
        case 30:
          this.txt_vc1 = emp_c;
          this.txt_vn1 = emp_n;
          this.txt_vc2 = vendor_c;
          this.txt_vn2 = vendir_n;
          this.in_no = rec_no;
          this.in_d = rec_d;
          this.txt_total = total_emp;
          this.sNetAmount = "";
          let nAdvanceAmount = this.Data[0].nAdvanceAmount;
          let nClearingAmount = this.Data[0].nClearingAmount - this.Data[0].nCumulativeAmount;;
          if (nClearingAmount > (nAdvanceAmount)) {
            this.sNetAmount = "Pay to employee";
          } else if (nClearingAmount < (nAdvanceAmount)) {
            this.sNetAmount = "Return to company";
          } else if (nClearingAmount == (nAdvanceAmount)) {
            this.sNetAmount = "Net total";
          }
          if (this.Data[0].nInvoiceType == 3) {
            this.sNetAmount = "Return Full Amount";
          }
          break
        case 40:
          this.txt_vc1 = vendor_c;
          this.txt_vn1 = vendir_n;
          this.txt_vc2 = vendor_c;
          this.txt_vn2 = vendir_n;
          this.in_no = rec_no;
          this.in_d = rec_d;
          this.txt_total = total_emp;
          break
      }
      //====================set button by Role=====================//
      switch (this.Data[0].nStatusID) {
        case 0:
          this.sRole = false;
          this.btnReject = false;
          this.btnApprove = false;
          this.btnPrint = false;
          this.btnRecall = false;
          this.Iscomment = true;
          this.Iscomment2 = true;
          break;
        case 1:
        case 3:
          if (this.nRole == 5 || this.nRole == 7) {
            this.sRole = false;
            this.btnReject = false;
            this.btnApprove = false;
            this.btnPrint = true;
            this.btnRecall = true;
          } else {
            this.sRole = true;
            this.btnReject = false;
            this.btnApprove = false;
            this.btnPrint = true;
            this.btnRecall = false;
            this.Iscomment = false;
          }
          break;
        case 2:
          if (this.nRole == 3) {
            this.sRole = true;
            this.btnReject = true;
            this.btnApprove = true;
            this.btnPrint = false;
            this.btnRecall = false;
          } else {
            if (this.nRole == 5 || this.nRole == 7) {
              this.sRole = false;
              this.btnReject = false;
              this.btnApprove = false;
              this.btnPrint = true;
              this.btnRecall = true;
              this.Iscomment = true;
            } else {
              this.sRole = false;
              this.btnReject = false;
              this.btnApprove = false;
              this.btnPrint = true;
              this.btnRecall = false;
              this.Iscomment = false;
            }
          }
          break;
        case 4:
          if (this.nRole == 4) {
            this.sRole = true;
            this.btnReject = true;
            this.btnApprove = true;
            this.btnPrint = false;
            this.btnRecall = false;
          }
          else {
            this.btnPrint = true;
            if (this.Data[0].cSkipApprove1 == "Y" && this.nRole == 5 || this.nRole == 7) {
              this.sRole = false;
              this.btnReject = false;
              this.btnApprove = false;
              this.btnPrint = true;
              this.btnRecall = true;
              this.Iscomment = true;
            }

          }
          break;
        default:
          this.sRole = false;
          this.btnReject = false;
          this.btnApprove = false;
          this.btnPrint = true;
      }
      if (!this.Iscomment) lastSection--;
      this.commentSSC = `Section ${lastSection + 1} : Remark to SSC`;
      this.TransactionHistory = `Section ${lastSection + 2} : Transaction History`;
      //====================================get file Path in page approve ================================//
      let folder = null;
      switch (this.Data[0].nReqType) {
        case 10:
          folder = "UploadFiles/PaytoPayment/";
          break;
        case 11:
          folder = "UploadFiles/PaytoOneTime/";
          break;
        case 12:
          folder = "UploadFiles/PaytoEmployee/";
          break;
        case 20:
          folder = "UploadFiles/AdvanceRequest/";
          break;
        case 30:
          folder = "UploadFiles/clearadvance/";
          break;
        case 40:
          folder = "UploadFiles/PettyCash/";
          break;
        case 50:
          folder = "UploadFiles/Other/";
          break;
        case 60:
          folder = "UploadFiles/PaytoPayment_CNType/";
          break;
        case 61:
          folder = "UploadFiles/PaytoOneTime_CNType/";
          break;
        case 70:
        case 71:
          folder = "UploadFiles/BillingToCash/";
          break;
        case 80:
          folder = "UploadFiles/JournalVoucher/";
          break;
        case 90:
          folder = "UploadFiles/ReceiptVoucher/";
          break;
        default:
          folder = "UploadFiles/Temp/";
          break;
      }
      //======================================== get file============================================//
      ArrFile.length = 0;
      if (this.nRole == 5 || this.nRole == 7) {
        let setUp = {
          sID: "dvUploadFile",
          nFileSize: 15,
          Extensions: Extension.PDF,
          ModeMulti: false,
          ArrFile: ArrFile,
          View: false,
          HasURL: true,
          UrlUpload: this.System.SiteName + "api/Approve/ChangeFile?savetopath=" + folder + this.sID + "/",
        };

        Uploadfiles(setUp);
        Clearuploadfile();
      }


      this.getFile(this.sID, this.nRole);
      this.System.UnBlockUI();
    });


  }
  //#endregion
  //#region 'getFile'
  getFile(index, nRole) {
    this.http.get<any>(this.System.SiteName + "api/Approve/GetFle/" + index).subscribe(res => {
      let data = res.File;
      let IsApprove = res.IsApprove;
      let arrdata: any[] = [];
      if (data) {
        data.forEach(f => arrdata.push({
          nID: f.nFileOrder,
          sPath: f.sPathFile,
          sSystemFileName: f.sSystemFileName,
          sFileName: f.sFileName,
          sSize: parseInt(f.sFileSize),
          IsNew: false
        }))
        
        // SetData('dvUploadFile', arrdata)
        createlist("dvUploadFile", arrdata);
      }
    });
  }
 
  IsInvtype: boolean = false;
  IsCheque: boolean = false;
  //===================================modal invoice=====================================//
  openModalWithClass(template: TemplateRef<any>, invoice: any, nitem: any) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-xl' })
    );
    let lstvendor: any
    //filter invoice by invoice and nItem No.
    lstvendor = this.TreqItem.filter(f => f.sInvoiceNo == invoice && f.nItemNo == nitem);
    this.IsInvtype = lstvendor[0].nInvoiceType == 1 ? true : false;
    this.IsInvtype = lstvendor[0].nVAT != null ? true : false;
    //if (this.nform == 2) {

    //  this.nform = lstvendor[0].nInvoiceType == 1 ? 4 : 2;
    //}

    //set data
    this.ApproveFrom.patchValue({
      sVendorCode_PX: lstvendor[0].sVendorCode,
      sVendorName_PX: lstvendor[0].sVendorName,
      sTAXID_PX: lstvendor[0].sTAXID,
      sVendorBranch_PX: lstvendor[0].sVendorBranch,
      sVendorAddress_PX: lstvendor[0].sVendorAddress,
      sInvoiceNo: lstvendor[0].sInvoiceNo,
      dInvoiceDate: new Date(lstvendor[0].dInvoiceDate),
      sInvoiceDesc: lstvendor[0].sInvoiceDesc,
      sVATType: lstvendor[0].sVATType,
      sCurrency: lstvendor[0].sCurrency,
      nExcludeVAT: lstvendor[0].nExcludeVAT,
      nVAT: lstvendor[0].nVAT,
      nIncludeVAT: lstvendor[0].nIncludeVAT,
      sWHTType: lstvendor[0].sWHTType,
      sWHTCode: lstvendor[0].sWHTCode,
      WHD_Desc: lstvendor[0].WHD_Desc,
      WHD_Desc2: lstvendor[0].WHD_Desc2,
      nWHTRate: lstvendor[0].nWHTRate,
      nWHTVal: lstvendor[0].nWHTVal,
      sWHTType2: lstvendor[0].sWHTType2,
      sWHTCode2: lstvendor[0].sWHTCode2,
      nWHTRate2: lstvendor[0].nWHTRate2,
      nWHTVal2: lstvendor[0].nWHTVal2,
      nWHTBase: lstvendor[0].nWHTBase,
      nWHTBase2: lstvendor[0].nWHTBase2,
      nOfficeType_PX: lstvendor[0].nOfficeType,
      sOfficeType_PX: lstvendor[0].nOfficeType == 1 ? "Head Office" : "Branch",
      IsVendorOneTime: lstvendor[0].IsVendorOneTime,
      sCountryID: lstvendor[0].sCountryName,
      sProvCode: lstvendor[0].sProvname,
      sAmpCode: lstvendor[0].sAmpName,
      sTumbonCode: lstvendor[0].sTumbonName,
      sPostCode: lstvendor[0].sPostCode,
      sPhoneNumber: lstvendor[0].sPhoneNumber,
      sFaxNumber: lstvendor[0].sFaxNumber,
      sEmail_vendor: lstvendor[0].sEmail_vendor,
      sAddressOneTime: lstvendor[0].sAddressOneTime,
    })

    //==================================onetime vendor==============================//
    let Isonetime = lstvendor[0].IsVendorOneTime;
    if (Isonetime) {
      this.onetimevendor = true;
    } else {
      this.onetimevendor = false;
    }
    if (lstvendor[0].sCountryID == 213) {
      this.IsCountryThai = true;
    } else {
      this.IsCountryThai = false;
    }

  }
  //===================================Event OnClick=====================================//
  //event Back,Reject,Approve,Print and Recall.
  onclick(index: string) {
    let _This = this;
    //if Reject or Recall need to comment.
    let IsComment = this.ApproveFrom.get('sComment').value != null ? (this.ApproveFrom.get('sComment').value != "" ? true : false) : false;
    switch (index) {
      case "Back":
        this.router.navigate(['/home'])
        break;
      case "Reject":
        if (IsComment) {
          this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.Desc_Confirm_Reject, function () {
            _This.System.BlockUI();
            _This.onReject();
          }, function () { _This.System.UnBlockUI() })
        } else {
          this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, "Please, specify comment", undefined)
        }
        break;
      case "Approve":
        this.ApproveFrom.get('sComment').markAsUntouched();
        this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.Desc_Confirm_Approve, function () {
          _This.System.BlockUI();
          _This.onApprove();
        }, function () { _This.System.UnBlockUI() })
        break;
      case "Print":
        this.Export();
        break;
      case "Recall":
        if (IsComment) {
          this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.Desc_Confirm_Recall, function () {
            _This.System.BlockUI();
            _This.OnRecall()
          }, function () { _This.System.UnBlockUI() })
        } else {
          this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, "Please, specify comment", undefined)
        }
        break;
    }
    _This.clicked = false;
  }
  //===================================onApprove=================================//
  onApprove() {
    let _this = this
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })
    let dates = this.BusinessDay.setDueDatebyDate(this.Settodate, this.ApproveFrom.get('dDueDate').value, this.holiday)
 
    switch (this.Data[0].nReqType) {
      case 80:
        this.urgentDay = 3;
        break
      case 70:
      case 71:
      case 90:
        this.urgentDay = 0;
        break
    }
    let IsUrgent = dates < this.urgentDay ? true : false;

    let Data = { sReqID: this.sReqID, sComment: this.ApproveFrom.get('sComment').value, sCommentSSC: this.ApproveFrom.get('sCommentSSC').value, IsUrgent: IsUrgent, nUrgentDay: dates, nUserID: this.nUserID, File: ArrFile }
    let ITEM = JSON.stringify(Data);
    this.http
      .post<any>(this.System.SiteName + 'api/Approve/SaveApprove', ITEM, { headers })
      .subscribe(res => {
        _this.System.UnBlockUI();
        if (res.Status == _this.System.SysProcess.SessionExpired) {
          _this.System.SessionExpire();
        }
        else if (res.Status == _this.System.SysProcess.Success) {
          _this.SW.SwAlert.Success(_this.SW.BoxMsg.Title_Success, _this.SW.BoxMsg.Desc_SaveComplete, function () {
            _this.router.navigate(['/home']);
            //Swal.close();
          });
        }
        else {
          _this.SW.SwAlert.Error(_this.SW.BoxMsg.Title_Error, res.Msg, undefined);
        }
      });
  }
  //===================================onReject==================================//
  onReject() {
    let _this = this
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })
    let Data = { sReqID: this.sReqID, sComment: this.ApproveFrom.get('sComment').value, sCommentSSC: this.ApproveFrom.get('sCommentSSC').value, nUserID: this.nUserID, File: ArrFile }
    let ITEM = JSON.stringify(Data);
    this.http
      .post<any>(this.System.SiteName + 'api/Approve/SaveReject', ITEM, { headers })
      .subscribe(res => {
        _this.System.UnBlockUI();
        if (res.Status == _this.System.SysProcess.SessionExpired) {
          _this.System.SessionExpire();
        }
        else if (res.Status == _this.System.SysProcess.Success) {
          _this.SW.SwAlert.Success(_this.SW.BoxMsg.Title_Success, _this.SW.BoxMsg.Desc_Success_Reject, function () {
            _this.router.navigate(['/home']);
            //Swal.close();
          });
        }
        else {
          _this.SW.SwAlert.Error(_this.SW.BoxMsg.Title_Error, res.Msg, undefined);
        }
      });
  }
  //===================================OnRecall==================================//
  OnRecall() {

    let _this = this
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })
    let comment = this.ApproveFrom.get('sComment').value;
    let Data = { sReqID: this.sReqID, nUserID: this.nUserID, sComment: comment, File: ArrFile }
    let ITEM = JSON.stringify(Data);
    this.http
      .post<any>(this.System.SiteName + 'api/Approve/RecallSubmit', ITEM, { headers })
      .subscribe(res => {
        _this.System.UnBlockUI();
        if (res.Status == _this.System.SysProcess.SessionExpired) {
          _this.System.SessionExpire();
        }
        else if (res.Status == _this.System.SysProcess.Success) {
          _this.SW.SwAlert.Success(_this.SW.BoxMsg.Title_Success, _this.SW.BoxMsg.Desc_Success_Recall, function () {
            _this.router.navigate(['/home']);
            //Swal.close();
          });
        }
        else {
          _this.SW.SwAlert.Error(_this.SW.BoxMsg.Title_Error, res.Msg, undefined);
        }
      });

  }
  //===================================export PDF================================//
  Export() {
    let nID = this.ApproveFrom.get("nContactID").value;
    const link = document.createElement('a');
    link.target = '_blank'
    const httpOptions = {
      params: new HttpParams()
        .set("sReqID", this.sReqID + "")
        .set("nContactID", nID),
    };
    link.href = this.System.SiteName + "api/ExportPDF/export?" + httpOptions.params
    link.setAttribute('visibility', 'hidden');
    link.click();
  }
  //===================================Validate==================================//
  //#region Validate
  isFieldValid(field: string) {
    return !this.ApproveFrom.get(field).valid && this.ApproveFrom.get(field).touched;
  }

  isEmailValid(field: string) {
    let input = this.ApproveFrom.get('sVendorEmail').value;
    let checkEmail: boolean = false
    let Regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (Regex.test(input)) {
      checkEmail = true
    }
    return !this.ApproveFrom.get(field).valid && this.ApproveFrom.get(field).touched && checkEmail;
  }

  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field),
      'has-feedback': this.isFieldValid(field)
    };
  }
  //#endregion
  //===================================uploadfile================================//
  Uploadfile() {
    let _this = this;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })

    let item = { sReqID: this.sReqID, File: ArrFile }
    this.http
      .post<any>(this.System.SiteName + 'api/Approve/SaveFile', item, { headers })
      .subscribe(res => {
        _this.System.UnBlockUI();
        if (res.Status == _this.System.SysProcess.SessionExpired) {
          _this.System.SessionExpire();
        }
        else if (res.Status == _this.System.SysProcess.Success) {
          _this.SW.SwAlert.Success(_this.SW.BoxMsg.Title_Success, _this.SW.BoxMsg.Desc_SaveComplete, function () {
            //Swal.close();
          });
        }
        else {
          _this.SW.SwAlert.Error(_this.SW.BoxMsg.Title_Error, res.Msg, undefined);
        }
      });
  }
  //====================================WorkFlow=================================//
  //#region WorkFlow
  ArrFlow = []
  BindFlow(sRequestID) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sRequestID", sRequestID)
    };
    this.http.get<any>(this.System.SiteName + "api/_System/BindFlow", httpOptions).subscribe(res => {
      if (res) {
        this.ArrFlow = res;
        let width: number = this.ArrFlow.length * 240;
        document.getElementById("DIV_FLOW").style.width = width + "px";
      }
    });
  }
  FlowICO(Item) {
    let sColor = "";
    switch (Item.cApprove) {
      case "A":
        sColor = Item.nFlowNo == 1 ? "fas fa-user-edit _flow_icon _text_green_paster" : "fas fa-user-check _flow_icon _text_green_paster";
        break;
      case "R":
      case "U":
        sColor = "fas fa-user-times _flow_icon _text_red_paster";
        break;
      case "W":
        sColor = "fas fa-user-clock _flow_icon _text_orange_paster";
        break;
    }
    return sColor;
  }
  FlowCommentDisplay(_Item, sCase) {
    let Display = false;
    switch (sCase) {
      case "1":
        if (_Item.sComment) {
          Display = (_Item.sComment.length > 15 ? false : true);
        }
        else {
          Display = true;
        }
        break;
      case "2":
        if (_Item.sComment) {
          Display = (_Item.sComment.length < 15 ? false : true);
        }
        break;
    }
    return Display;
  }

  OpenComment(template: TemplateRef<any>, Item) {
    this.sModalDetail = Item.sComment;
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-xl' })
    );
  }
  //#endregion


}
